module.exports = __webpack_public_path__ + "img/page7.7f51dc9c.png";